import type { Language, ObjectValues } from '../../types/types';

export const themes = {
  basic: 'basic',
  pride: 'pride',
};

export const variants = {
  letter: 'letter',
  full: 'full',
};

type LogoBase = {
  className?: string;
  language: Language;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
};

type LogoLink = LogoBase & {
  href: string;
  label: string;
};

type LogoStatic = LogoBase & {
  href?: undefined;
  label?: undefined;
};

export type Logo = LogoLink | LogoStatic;
